import logo from './logo.json';
import styles from './Logo.module.css';

export interface LogoProps {
  /** Rendered size in CSS units; below 32 px the simplified favicon mark is used. */
  size?: number;
  /** Single color (currentColor), e.g. on colored or busy surfaces. */
  mono?: boolean;
  className?: string;
}

/**
 * swarm image mark (issue #175): three honey cells as a comb, two smaller cells
 * swarming out. Geometry comes from logo.json, the single source of every logo
 * file; colors follow the theme (--color-brand, --color-brand-ink).
 */
export function Logo({ size = 24, mono = false, className }: LogoProps) {
  const geometry = size < 32 ? logo.small : logo.mark;
  return (
    <svg
      viewBox={geometry.viewBox}
      width={size}
      height={size}
      className={`${styles.logo} ${mono ? styles.mono : ''} ${className ?? ''}`}
      aria-hidden="true"
      focusable="false"
    >
      <path d={geometry.comb} className={styles.comb} />
      <path d={geometry.swarm} className={styles.swarm} />
    </svg>
  );
}
